import axios from 'axios';
import Swal from 'sweetalert2';

const $http = axios.create({
    baseURL: process.env.FIREBASE_DATABASE_URL,
});


$http.interceptors.response.use(resp => resp, error => {
    if (error.response.status == 401) {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Your session has expired, please log in again.',
            showConfirmButton: false,
            timer: 8000
        }).then(
            localStorage.clear(),
            document.location.href = "/the-magazine",
        )
    } else {
        window.location.href = "/the-magazine"
        localStorage.clear()
    }

    return Promise.reject(error)
}) 

$http.interceptors.response.use(response => {

    return response
})


export default $http;